import SelectedItemsTable from './selected-items-table';

export default SelectedItemsTable;
